/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ZandaHealth API
 * OpenAPI spec version: 1.0
 */

export type AppointmentButtonStatus =
  (typeof AppointmentButtonStatus)[keyof typeof AppointmentButtonStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppointmentButtonStatus = {
  NotVisible: 0,
  Disabled: 1,
  Enabled: 2,
} as const;
